module.exports = __webpack_public_path__ + "static/media/location_berlin.e1202b18.jpg";